exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".events-loader{position:relative;height:635px;overflow:hidden}@media(min-width: 1160px){.events-loader{height:568px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/events-list/loader/style.scss
// module id = 1444
// module chunks = 58